"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.Record({
  id: null,
  name: null,
  htmlTitle: null,
  absoluteUrl: null,
  subcategory: null,
  portalId: null,
  categoryId: null,
  contentGroupId: null,
  readOnly: null,
  sitemapCaptegory: null
}, 'PageForSitemap');

exports.default = _default;
module.exports = exports.default;